import classNames from 'classnames/bind';
import { Formik, Form } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';

import Button from 'uikit/Button';
import InputFile from 'uikit/InputFile';
import InputRich2 from 'uikit/InputRich2';
import Select from 'uikit/Select';

import styles from './QuestionImportFile.module.scss';

const cx = classNames.bind(styles);

const QuestionImportFile = ({
  ankiSettings,
  chapters,
  handleQuestionsImport,
  handleQuestionsImportAnki,
  t,
  validationSchema,
}) =>
  ankiSettings ? (
    <>
      <Formik
        key="anki"
        initialValues={{
          recto:
            '<p class="fr-class-title fr-class-horizontal-center">[[Front]]</p>',
          verso:
            '<p class="fr-class-title fr-class-horizontal-center">[[Back]]</p>',
        }}
        onSubmit={handleQuestionsImportAnki}
      >
        {({ isSubmitting }) => (
          <Form className={cx('subpage')}>
            <div className={cx('subtitle')}>
              <p>
                {t(
                  'Course/Teacher/Editor/QuestionImport/QuestionImportFile/anki-fields',
                  { column: ankiSettings.columns[0] },
                )}
              </p>
              <p>
                <strong>{ankiSettings.columns.join(', ')}</strong>
              </p>
            </div>
            <InputRich2
              className={cx('field')}
              name="recto"
              label={t(
                'Course/Teacher/Editor/QuestionImport/QuestionImportFile/front',
              )}
            />
            <InputRich2
              className={cx('field')}
              name="verso"
              label={t(
                'Course/Teacher/Editor/QuestionImport/QuestionImportFile/back',
              )}
            />
            <div className={cx('actions')}>
              <div />
              <Button
                className={cx('action')}
                intent="primary"
                isLoading={isSubmitting}
                size="large"
                type="submit"
              >
                {t(
                  'Course/Teacher/Editor/QuestionImport/QuestionImportFile/confirm-import-anki',
                )}
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  ) : (
    <>
      <Formik
        key="file"
        initialValues={{
          chapterId: '',
          file: null,
        }}
        onSubmit={handleQuestionsImport}
        validationSchema={validationSchema}
      >
        {({ isSubmitting, status }) => (
          <Form className={cx('subpage')}>
            <div className={cx('subtitle')}>
              <p>
                {t(
                  'Course/Teacher/Editor/QuestionImport/QuestionImportFile/subtitle',
                )}
              </p>
              <p>
                <a
                  href={t(
                    'Course/Teacher/Editor/QuestionImport/QuestionImportFile/excel-link',
                  )}
                  target="blank"
                >
                  {t(
                    'Course/Teacher/Editor/QuestionImport/QuestionImportFile/excel-download',
                  )}
                </a>
              </p>
              <p>
                <a
                  href={t(
                    'Course/Teacher/Editor/QuestionImport/QuestionImportFile/csv-link',
                  )}
                  target="blank"
                >
                  {t(
                    'Course/Teacher/Editor/QuestionImport/QuestionImportFile/csv-download',
                  )}
                </a>
              </p>
            </div>
            {status === '500' && (
              <p className={cx('error')} role="alert">
                {t(
                  'Course/Teacher/Editor/QuestionImport/QuestionImportFile/question-import-error',
                )}
              </p>
            )}
            <Select
              className={cx('field')}
              icon="book-open"
              label={t(
                'Course/Teacher/Editor/QuestionImport/QuestionImportFile/chapter-label',
              )}
              name="chapterId"
            >
              <option value="">
                {t(
                  'Course/Teacher/Editor/QuestionImport/QuestionImportFile/no-chapter',
                )}
              </option>
              {chapters.map((chapter) => (
                <option key={chapter.id} value={chapter.id}>
                  {chapter.title}
                </option>
              ))}
            </Select>
            <InputFile
              accept=".xml,.xls,.xlsx,.ods,.csv,.ppt,.pptx,.pps,.pot,.ppsx,.potx,.odp, .key, .pdf, .apkg"
              className={cx('field')}
              icon="file-code"
              label={t(
                'Course/Teacher/Editor/QuestionImport/QuestionImportFile/file-label',
              )}
              name="file"
            />
            <div className={cx('actions')}>
              <div />
              <Button
                className={cx('action')}
                intent="primary"
                isLoading={isSubmitting}
                size="large"
                type="submit"
              >
                {t(
                  'Course/Teacher/Editor/QuestionImport/QuestionImportFile/confirm-import-questions',
                )}
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );

QuestionImportFile.propTypes = {
  ankiSettings: PropTypes.object.isRequired,
  chapters: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleQuestionsImport: PropTypes.func.isRequired,
  handleQuestionsImportAnki: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  validationSchema: PropTypes.object.isRequired,
};

export default QuestionImportFile;
